export default __webpack_public_path__ + "static/media/Pha_Wan1.af555519.webp";